export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-Cyrillic-66c005fe6d8c875c9aeb80585e6fcd84.woff";